import clsx from 'clsx';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@/shared/components/atoms';

const FAQ: React.FC<{ number: number; open?: boolean; border?: boolean }> = ({
  number,
  open,
  border,
}) => {
  const { t } = useTranslation('payment');
  const [isOpen, setIsOpen] = useState<boolean>(() => open ?? false);
  return (
    <div
      className={clsx(
        'flex flex-col gap-2 py-16 transition-all duration-1000 ease-in-out',
        border && 'border-b-xs border-background-200'
      )}
    >
      <div
        className='flex cursor-pointer items-center justify-between gap-2'
        onClick={() => setIsOpen((val) => !val)}
      >
        <span>{t(`faq-title#${number}`)}</span>
        <span className='relative flex h-20 w-20 items-center justify-center rounded-full border-sm border-surface-10'>
          <span
            className={clsx(
              'absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2',
              'h-[2px] w-[8px] overflow-hidden rounded-sm bg-surface-10'
            )}
          ></span>
          <span
            className={clsx(
              'absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2',
              'h-[2px] w-[8px] overflow-hidden rounded-sm bg-surface-10',
              'transition-all duration-300 ease-in-out',
              isOpen && 'rotate-90'
            )}
          ></span>
        </span>
      </div>
      {/* TODO: update animation */}
      <Typography
        variant='body2'
        className={clsx(
          'overflow-hidden text-grey-600 transition-all duration-1000 ease-in-out',
          isOpen && 'h-0'
        )}
      >
        {t(`faq-description#${number}`)}
      </Typography>
    </div>
  );
};

export { FAQ };
